var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9C19.9871 9 23.3042 11.869 24 15.655C23.3049 19.4409 19.9871 22.3099 16 22.3099C12.0129 22.3099 8.69581 19.4409 8 15.655C8.69507 11.869 12.0129 9 16 9ZM16 20.831C17.5081 20.8307 18.9714 20.3185 20.1504 19.3782C21.3294 18.4379 22.1543 17.1252 22.4901 15.655C22.1531 14.1859 21.3276 12.8747 20.1487 11.9356C18.9698 10.9965 17.5072 10.4852 16 10.4852C14.4928 10.4852 13.0302 10.9965 11.8513 11.9356C10.6724 12.8747 9.84695 14.1859 9.50994 15.655C9.84571 17.1252 10.6706 18.4379 11.8496 19.3782C13.0286 20.3185 14.4919 20.8307 16 20.831V20.831ZM16 18.9824C15.1175 18.9824 14.2711 18.6319 13.6471 18.0078C13.0231 17.3838 12.6725 16.5375 12.6725 15.655C12.6725 14.7725 13.0231 13.9261 13.6471 13.3021C14.2711 12.6781 15.1175 12.3275 16 12.3275C16.8825 12.3275 17.7289 12.6781 18.3529 13.3021C18.9769 13.9261 19.3275 14.7725 19.3275 15.655C19.3275 16.5375 18.9769 17.3838 18.3529 18.0078C17.7289 18.6319 16.8825 18.9824 16 18.9824ZM16 17.5036C16.4903 17.5036 16.9605 17.3088 17.3072 16.9621C17.6538 16.6154 17.8486 16.1452 17.8486 15.655C17.8486 15.1647 17.6538 14.6945 17.3072 14.3478C16.9605 14.0011 16.4903 13.8064 16 13.8064C15.5097 13.8064 15.0395 14.0011 14.6928 14.3478C14.3462 14.6945 14.1514 15.1647 14.1514 15.655C14.1514 16.1452 14.3462 16.6154 14.6928 16.9621C15.0395 17.3088 15.5097 17.5036 16 17.5036Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSmall);
export default __webpack_public_path__ + "static/media/eye-small.882977e7.svg";
export { ForwardRef as ReactComponent };